import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ChancenkurveThresholdTransition } from './ChancenkurveThresholdTransition.js';

/**
 * Configuration for a single level/station in the Chancenkurve system
 */
@Entity()
export class ChancenkurveLevelConfig extends AdornisEntity {
  static override _class = 'ChancenkurveLevelConfig';

  /**
   * Resolve unique ID for this entity using levelId
   * Required for BaseQL to merge entities in arrays
   */
  static override resolveID(data: Partial<ChancenkurveLevelConfig>): string {
    return data.levelId || '';
  }

  /**
   * Unique identifier for this level (e.g., "N4", "Station2")
   */
  @Field(() => String)
  levelId: Maybe<string>;

  /**
   * Display name for this level (e.g., "N4", "Station 2")
   */
  @Field(() => String)
  name: Maybe<string>;

  /**
   * Lesson ID associated with this level
   */
  @Field(() => String)
  lessonId: Maybe<string>;

  /**
   * Criteria for upgrading to a higher level
   */
  @Field(() => ChancenkurveThresholdTransition)
  moveUp: Maybe<ChancenkurveThresholdTransition>;

  /**
   * Criteria for downgrading to a lower level
   */
  @Field(() => ChancenkurveThresholdTransition)
  moveDown: Maybe<ChancenkurveThresholdTransition>;

  /**
   * Criteria for downgrading multiple levels (e.g., Station 4 -> Station 2)
   */
  @Field(() => ChancenkurveThresholdTransition)
  moveDownFar: Maybe<ChancenkurveThresholdTransition>;
}
